export default __webpack_public_path__ + "static/about-header-4ea5158450f498297a4c1fe52f19c848.png";